module.exports = __webpack_public_path__ + "static/2-man-walking-bb6c75f51a4ff9f3b810db301eaa3fe6.jpg";